/* Stemori — scripts propios (sin librerías). */
(function () {
  'use strict';

  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;
    document.querySelectorAll('.mt-benefits, .mt-bento, .mt-steps__text, .mt-faq, .mt-table, .mt-trust, .mt-trustrow, .mt-swatches').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.classList.add('mt-reveal'); c.style.setProperty('--mt-i', i); });
    });
    items = document.querySelectorAll('.mt-reveal');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
          (function (t) { setTimeout(function () { t.style.setProperty('--mt-i', 0); }, 1600); })(e.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-mt-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var currency = root.getAttribute('data-currency') || 'USD';
    var discount = parseFloat(root.getAttribute('data-discount') || '10');
    var idInput = root.querySelector('[data-mt-id]');
    var priceEl = root.querySelector('[data-mt-price]');
    var comparEl = root.querySelector('[data-mt-compare]');
    var price1 = root.querySelector('[data-mt-price-1]');
    var price2 = root.querySelector('[data-mt-price-2]');
    var btn = root.querySelector('[data-mt-add]');
    var msg = root.querySelector('[data-mt-msg]');
    var second = root.querySelector('[data-mt-second]');
    var secondSelect = root.querySelector('[data-mt-second-select]');
    var mainImg = root.querySelector('[data-mt-main]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var sticky = root.querySelector('[data-mt-sticky]');
    var stickyPrice = root.querySelector('[data-mt-sticky-price]');
    var stickyBtn = root.querySelector('[data-mt-sticky-btn]');
    var addLabel = btn ? btn.getAttribute('data-label-add') : 'Add to cart';
    var soldLabel = btn ? btn.getAttribute('data-label-sold') : 'Sold out';

    function selected() {
      var vals = [];
      root.querySelectorAll('[data-mt-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[parseInt(fs.getAttribute('data-mt-option'), 10)] = c ? c.value : null;
      });
      return vals;
    }
    function current() {
      var sel = selected();
      if (!sel.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      }) || null;
    }
    function setMain(src, alt) {
      if (!mainImg || !src || mainImg.getAttribute('src') === src) return;
      var next = new Image();
      mainImg.classList.add('is-swapping');
      next.onload = next.onerror = function () {
        mainImg.src = src;
        if (alt != null) mainImg.alt = alt;
        window.requestAnimationFrame(function () { mainImg.classList.remove('is-swapping'); });
      };
      next.src = src;
    }
    function bump(el) {
      if (!el) return;
      el.classList.remove('is-changing');
      void el.offsetWidth;
      el.classList.add('is-changing');
    }
    function update() {
      var v = current();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = soldLabel; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) { var oldP = priceEl.textContent; priceEl.textContent = money(v.price, currency); if (oldP !== priceEl.textContent) bump(priceEl); }
      if (comparEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparEl.textContent = money(v.compare_at_price, currency);
          comparEl.hidden = false;
        } else { comparEl.hidden = true; }
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price, currency);
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? addLabel : soldLabel; }
      if (price1) price1.textContent = money(v.price, currency);
      if (price2) price2.textContent = money(2 * (v.price - Math.floor(v.price * discount / 100)), currency);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? addLabel : soldLabel;
      }
      if (v.featured_media && v.featured_media.id) {
        thumbs.forEach(function (t) {
          if (String(t.getAttribute('data-media-id')) === String(v.featured_media.id)) t.click();
        });
      }
      if (secondSelect && !secondSelect.getAttribute('data-touched')) secondSelect.value = String(v.id);
    }

    root.querySelectorAll('[data-mt-option] input').forEach(function (i) { i.addEventListener('change', update); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        setMain(t.getAttribute('data-large'), t.getAttribute('data-alt'));
      });
    });
    root.querySelectorAll('[data-mt-set]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (second) second.classList.toggle('is-open', r.value === '2' && r.checked);
      });
    });
    if (secondSelect) secondSelect.addEventListener('change', function () { secondSelect.setAttribute('data-touched', '1'); });
    try {
      if (new URLSearchParams(window.location.search).get('set') === '2') {
        var r2 = root.querySelector('[data-mt-set][value="2"]');
        if (r2) { r2.checked = true; if (second) second.classList.add('is-open'); }
      }
    } catch (err) { /* sin parámetro, no pasa nada */ }

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var v = current();
        if (!v || !v.available) { e.preventDefault(); return; }
        var setRadio = root.querySelector('[data-mt-set]:checked');
        var qty2 = setRadio && setRadio.value === '2';
        if (!window.fetch) return; /* el formulario normal añade 1 unidad */
        e.preventDefault();
        var items;
        if (qty2) {
          var id2 = secondSelect ? parseInt(secondSelect.value, 10) : v.id;
          items = (id2 === v.id) ? [{ id: v.id, quantity: 2 }] : [{ id: v.id, quantity: 1 }, { id: id2, quantity: 1 }];
        } else {
          items = [{ id: v.id, quantity: 1 }];
        }
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        if (msg) msg.textContent = '';
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (res.ok) {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            } else {
              if (msg) msg.textContent = res.body.description || res.body.message || 'Could not add to cart.';
              if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
            }
          })
          .catch(function () {
            if (msg) msg.textContent = 'Something went wrong. Please try again.';
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          });
      });
    }
    if (sticky && btn && 'IntersectionObserver' in window) {
      var buyBox = root.querySelector('.mt-qtyrow') || btn;
      var seen = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { seen = true; }
          var show = !e.isIntersecting && seen && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      }, { threshold: 0 }).observe(buyBox);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (form && form.requestSubmit) { form.requestSubmit(btn); } else { btn.click(); }
      });
    }
    update();
  }

  function initColors(root) {
    var sws = root.querySelectorAll('[data-mt-swatch]');
    var slides = root.querySelectorAll('[data-mt-slide]');
    var stage = root.querySelector('[data-mt-stage]');
    var nameEl = root.querySelector('[data-mt-color-name]');
    function select(i, focus) {
      sws.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
      });
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        if (k === i) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      var b = sws[i];
      if (stage && b) stage.style.setProperty('--tint', b.style.getPropertyValue('--tint'));
      if (nameEl && b) nameEl.textContent = b.getAttribute('data-name');
    }
    sws.forEach(function (b, i) {
      b.tabIndex = i === 0 ? 0 : -1;
      b.addEventListener('click', function () { select(i, false); });
      b.addEventListener('keydown', function (e) {
        var n = sws.length, j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
        if (j !== null) { e.preventDefault(); select(j, true); }
      });
    });
  }

  function initSkeletons() {
    document.querySelectorAll('.mt-skel').forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) { box.classList.add('is-loaded'); return; }
      function done() { box.classList.add('is-loaded'); }
      if (img.complete && img.naturalWidth) { done(); } else { img.addEventListener('load', done); img.addEventListener('error', done); }
    });
  }

  function initScrollFx() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var bar = document.createElement('div');
    bar.className = 'mt-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var imgs = document.querySelectorAll('.mt-hero__media .mt-img, .mt-feature__media .mt-img, .mt-steps__media .mt-img, .mt-bento__media .mt-img');
    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      document.body.classList.toggle('mt-scrolled', y > 40);
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5 .. 0.5 aprox */
        img.style.setProperty('--mt-py', (p * -28).toFixed(1) + 'px');
      });
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }


  function initHomeSticky(root) {
    var bar = root.querySelector('[data-mt-home-sticky]');
    var cta = root.querySelector('[data-mt-home-cta]');
    var btn = root.querySelector('[data-mt-home-sticky-btn]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
      });
    }, { threshold: 0 }).observe(cta);
  }

  function initSavings(root) {
    var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
    var pct = parseFloat(root.getAttribute('data-pct')) || 0;
    var cur = root.getAttribute('data-currency') || 'USD';
    var range = root.querySelector('[data-mt-qty]');
    if (!unit || !range) return;
    var out = {
      qty: root.querySelector('[data-mt-q]'), full: root.querySelector('[data-mt-full]'), now: root.querySelector('[data-mt-now]'),
      barFull: root.querySelector('[data-mt-bar-full]'), barNow: root.querySelector('[data-mt-bar-now]'),
      save: root.querySelector('[data-mt-save]'), note: root.querySelector('[data-mt-note]'), label: root.querySelector('[data-mt-label]')
    };
    function fmt(c) { return money(c, cur); }
    function update() {
      var q = parseInt(range.value, 10);
      var full = unit * q;
      var disc = q >= 2 ? q * (unit - Math.floor(unit * pct / 100)) : full;
      range.setAttribute('aria-valuetext', q + (q === 1 ? ' file' : ' files'));
      range.style.setProperty('--mt-fill', ((q - 1) / (parseInt(range.max, 10) - 1) * 100) + '%');
      if (out.qty) out.qty.textContent = q + (q === 1 ? ' file' : ' files');
      if (out.full) out.full.textContent = fmt(full);
      if (out.now) out.now.textContent = fmt(disc);
      if (out.barFull) out.barFull.style.setProperty('--w', '100%');
      if (out.barNow) out.barNow.style.setProperty('--w', (disc / full * 100) + '%');
      if (out.save) out.save.textContent = full - disc > 0 ? fmt(full - disc) : fmt(0);
      if (out.note) out.note.textContent = q >= 2 ? 'Discount applied automatically at checkout.' : 'Add a second file to unlock ' + pct + '% off.';
      root.classList.toggle('has-discount', q >= 2);
      root.querySelectorAll('[data-mt-quick]').forEach(function (b) { b.classList.toggle('is-on', parseInt(b.getAttribute('data-mt-quick'), 10) === q); });
    }
    range.addEventListener('input', update);
    root.querySelectorAll('[data-mt-quick]').forEach(function (b) {
      b.addEventListener('click', function () { range.value = b.getAttribute('data-mt-quick'); update(); });
    });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSkeletons();
    initReveal();
    initScrollFx();
    document.querySelectorAll('[data-mt-colors]').forEach(initColors);
    document.querySelectorAll('[data-mt-home-hero]').forEach(initHomeSticky);
    document.querySelectorAll('[data-mt-savings]').forEach(initSavings);
    document.querySelectorAll('[data-mt-product]').forEach(initProduct);
  });
})();
